import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import {
  TextField, ListItem, ListItemText,
  Dialog, DialogTitle, DialogContent,
} from '@material-ui/core';
import AssignmentIcon from '@material-ui/icons/Assignment';
import DeleteIcon from '@material-ui/icons/Delete';
import Button from '@material-ui/core/Button';
import { I18n } from 'react-redux-i18n';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import DialogDynamicsField from './DialogDynamicsField';

import globalStyles from '../../../styles';

const styles = theme => ({
  paper: {
    position: 'absolute',
    width: theme.spacing.unit * 60,
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing.unit * 4,
  },
});

const List = props => (
  props.items.map((item, i) => (
    <ListItem key={i}>
      <ListItemText inset primary={item} />
      <Tooltip title={I18n.t('button.delete')}>
        <IconButton aria-label="Delete" onClick={() => props.onClickRemove(item, i)}>
          <DeleteIcon />
        </IconButton>
      </Tooltip>
      <Tooltip title={I18n.t('button.add_dynamic_fields')}>
        <IconButton aria-label={I18n.t('fields.add_dynamic_fields')} onClick={() => props.onClickEdit(item, i)}>
          <AssignmentIcon />
        </IconButton>
      </Tooltip>
    </ListItem>
  ))
);

class ModalCreateStep extends React.Component {

  constructor(props) {

    super(props);
    this.state = {
      ModalDynamicField: false,
      open: false,
      Fases: [],
      inputValue: '',
      StepsList: [],
      indexAtual: 0,
    };
    this.handleClose = this.handleClose.bind(this);
    this.handleEditOpen = this.handleEditOpen.bind(this);

  }

  onClick = () => {

    const { inputValue, Fases, StepsList } = this.state;
    const currentIndex = StepsList.map(obj => obj.name).indexOf(inputValue);

    if (inputValue) {

      const nextState = [...Fases, inputValue];

      this.setState({
        Fases: nextState,
        inputValue: '',
      });

      const step = {
        name: inputValue,
        position: StepsList.length,
        fieldsList: [],
      };

      if (currentIndex === -1) StepsList.push(step);

    }

  }

  handleEditOpen = (name, position) => {

    this.setState({ ModalDynamicField: true, indexAtual: position });

  };

  handleItemClickRemove = (e) => {

    const { Fases } = this.state;

    this.setState({ Fases: this.removeA(Fases, e) });

  }

  removeA(arr) {

    const { StepsList } = this.state;

    let what; let a = arguments; let L = a.length; let
      ax;
    while (L > 1 && arr.length) {

      what = a[--L];
      while ((ax = arr.indexOf(what)) !== -1) arr.splice(ax, 1);


    }
    const index = StepsList.map(obj => obj.name).indexOf(what);
    if (index !== -1) StepsList.splice(index, 1);

    return arr;

  }

  handleClose = response => (event) => {

    this.setState({ ModalDynamicField: false });

  }

  onChange = (e) => {

    this.setState({ inputValue: e.target.value });

  };


  render() {

    const {
      classes, onClose, open, workflow,
    } = this.props;
    const {
      Fases, inputValue, ModalDynamicField, StepsList, indexAtual,
    } = this.state;

    return (
      <div>
        <Dialog
          open={open}
          onClose={() => onClose(StepsList)}
          maxWidth="md"
        >
          <div>
            <DialogTitle>
              {I18n.t('titles.phase_creation')}
              {workflow && ` - ${I18n.t('fields.flow')}: ${workflow.name}`}
            </DialogTitle>
            <DialogContent>
              <div style={{ minWidth: 600, maxWidth: 800, maxHeight: 800 }}>
                <TextField
                  id="stepName"
                  label="Nome da fase"
                  value={inputValue}
                  style={globalStyles.textField}
                  onChange={this.onChange}
                  margin="normal"
                  autoComplete={false}
                  onKeyPress={(event) => {

                    if (event.key === 'Enter') this.onClick();

                  }}
                />
                <Button onClick={this.onClick} color="primary" variant="contained">
                  {I18n.t('button.create')}
                </Button>


                {Fases.length > 0 && <List items={Fases} onClickEdit={this.handleEditOpen} onClickRemove={this.handleItemClickRemove} />}
              </div>
            </DialogContent>
            <DialogDynamicsField
              open={ModalDynamicField}
              onClose={response => this.handleClose(response)}
              data={StepsList[indexAtual]}
            />
          </div>
        </Dialog>
      </div>
    );

  }
}

ModalCreateStep.propTypes = {
  classes: PropTypes.object.classe,
};


export default withStyles(styles)(ModalCreateStep);



// WEBPACK FOOTER //
// ./src/components/tracker/WorkFlow/ModalCreateStep.js